/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MfaRouteImport } from './routes/mfa'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as TicketIdRouteImport } from './routes/ticket.$id'
import { Route as AuthenticatedChangePasswordRouteImport } from './routes/_authenticated/change-password'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin.users'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin.settings'
import { Route as AuthenticatedAdminPricingRouteImport } from './routes/_authenticated/admin.pricing'
import { Route as AuthenticatedAdminMaterialsRouteImport } from './routes/_authenticated/admin.materials'
import { Route as AuthenticatedAdminLogsRouteImport } from './routes/_authenticated/admin.logs'
import { Route as AuthenticatedAdminInvoicesRouteImport } from './routes/_authenticated/admin.invoices'
import { Route as AuthenticatedAdminClientsRouteImport } from './routes/_authenticated/admin.clients'

const MfaRoute = MfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const TicketIdRoute = TicketIdRouteImport.update({
  id: '/ticket/$id',
  path: '/ticket/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedChangePasswordRoute =
  AuthenticatedChangePasswordRouteImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminSettingsRoute =
  AuthenticatedAdminSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminPricingRoute =
  AuthenticatedAdminPricingRouteImport.update({
    id: '/pricing',
    path: '/pricing',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminMaterialsRoute =
  AuthenticatedAdminMaterialsRouteImport.update({
    id: '/materials',
    path: '/materials',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminLogsRoute = AuthenticatedAdminLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminInvoicesRoute =
  AuthenticatedAdminInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminClientsRoute =
  AuthenticatedAdminClientsRouteImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/mfa': typeof MfaRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/change-password': typeof AuthenticatedChangePasswordRoute
  '/ticket/$id': typeof TicketIdRoute
  '/admin/clients': typeof AuthenticatedAdminClientsRoute
  '/admin/invoices': typeof AuthenticatedAdminInvoicesRoute
  '/admin/logs': typeof AuthenticatedAdminLogsRoute
  '/admin/materials': typeof AuthenticatedAdminMaterialsRoute
  '/admin/pricing': typeof AuthenticatedAdminPricingRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/mfa': typeof MfaRoute
  '/change-password': typeof AuthenticatedChangePasswordRoute
  '/ticket/$id': typeof TicketIdRoute
  '/': typeof AuthenticatedIndexRoute
  '/admin/clients': typeof AuthenticatedAdminClientsRoute
  '/admin/invoices': typeof AuthenticatedAdminInvoicesRoute
  '/admin/logs': typeof AuthenticatedAdminLogsRoute
  '/admin/materials': typeof AuthenticatedAdminMaterialsRoute
  '/admin/pricing': typeof AuthenticatedAdminPricingRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/mfa': typeof MfaRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/change-password': typeof AuthenticatedChangePasswordRoute
  '/ticket/$id': typeof TicketIdRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/admin/clients': typeof AuthenticatedAdminClientsRoute
  '/_authenticated/admin/invoices': typeof AuthenticatedAdminInvoicesRoute
  '/_authenticated/admin/logs': typeof AuthenticatedAdminLogsRoute
  '/_authenticated/admin/materials': typeof AuthenticatedAdminMaterialsRoute
  '/_authenticated/admin/pricing': typeof AuthenticatedAdminPricingRoute
  '/_authenticated/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/_authenticated/admin/users': typeof AuthenticatedAdminUsersRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/mfa'
    | '/admin'
    | '/change-password'
    | '/ticket/$id'
    | '/admin/clients'
    | '/admin/invoices'
    | '/admin/logs'
    | '/admin/materials'
    | '/admin/pricing'
    | '/admin/settings'
    | '/admin/users'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/mfa'
    | '/change-password'
    | '/ticket/$id'
    | '/'
    | '/admin/clients'
    | '/admin/invoices'
    | '/admin/logs'
    | '/admin/materials'
    | '/admin/pricing'
    | '/admin/settings'
    | '/admin/users'
    | '/admin'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/mfa'
    | '/_authenticated/admin'
    | '/_authenticated/change-password'
    | '/ticket/$id'
    | '/_authenticated/'
    | '/_authenticated/admin/clients'
    | '/_authenticated/admin/invoices'
    | '/_authenticated/admin/logs'
    | '/_authenticated/admin/materials'
    | '/_authenticated/admin/pricing'
    | '/_authenticated/admin/settings'
    | '/_authenticated/admin/users'
    | '/_authenticated/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  MfaRoute: typeof MfaRoute
  TicketIdRoute: typeof TicketIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/mfa': {
      id: '/mfa'
      path: '/mfa'
      fullPath: '/mfa'
      preLoaderRoute: typeof MfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/ticket/$id': {
      id: '/ticket/$id'
      path: '/ticket/$id'
      fullPath: '/ticket/$id'
      preLoaderRoute: typeof TicketIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/change-password': {
      id: '/_authenticated/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthenticatedChangePasswordRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/users': {
      id: '/_authenticated/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/settings': {
      id: '/_authenticated/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthenticatedAdminSettingsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/pricing': {
      id: '/_authenticated/admin/pricing'
      path: '/pricing'
      fullPath: '/admin/pricing'
      preLoaderRoute: typeof AuthenticatedAdminPricingRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/materials': {
      id: '/_authenticated/admin/materials'
      path: '/materials'
      fullPath: '/admin/materials'
      preLoaderRoute: typeof AuthenticatedAdminMaterialsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/logs': {
      id: '/_authenticated/admin/logs'
      path: '/logs'
      fullPath: '/admin/logs'
      preLoaderRoute: typeof AuthenticatedAdminLogsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/invoices': {
      id: '/_authenticated/admin/invoices'
      path: '/invoices'
      fullPath: '/admin/invoices'
      preLoaderRoute: typeof AuthenticatedAdminInvoicesRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/clients': {
      id: '/_authenticated/admin/clients'
      path: '/clients'
      fullPath: '/admin/clients'
      preLoaderRoute: typeof AuthenticatedAdminClientsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminClientsRoute: typeof AuthenticatedAdminClientsRoute
  AuthenticatedAdminInvoicesRoute: typeof AuthenticatedAdminInvoicesRoute
  AuthenticatedAdminLogsRoute: typeof AuthenticatedAdminLogsRoute
  AuthenticatedAdminMaterialsRoute: typeof AuthenticatedAdminMaterialsRoute
  AuthenticatedAdminPricingRoute: typeof AuthenticatedAdminPricingRoute
  AuthenticatedAdminSettingsRoute: typeof AuthenticatedAdminSettingsRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminClientsRoute: AuthenticatedAdminClientsRoute,
  AuthenticatedAdminInvoicesRoute: AuthenticatedAdminInvoicesRoute,
  AuthenticatedAdminLogsRoute: AuthenticatedAdminLogsRoute,
  AuthenticatedAdminMaterialsRoute: AuthenticatedAdminMaterialsRoute,
  AuthenticatedAdminPricingRoute: AuthenticatedAdminPricingRoute,
  AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,
  AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedChangePasswordRoute: typeof AuthenticatedChangePasswordRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedChangePasswordRoute: AuthenticatedChangePasswordRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  MfaRoute: MfaRoute,
  TicketIdRoute: TicketIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
